export class SignOut {
  static readonly type = '[Auth] SignOut';
}
